import RequestBase from "./RequestBase.ts";

export default class ApiKeyRequests extends RequestBase {
    constructor(){
        super("apikey/");
    }

    ResetKey = (keyId, onSuccess) => 
    {
        this.defaultAxios.post(`restart/${keyId}`, {})
        .then((res) => 
        {
            onSuccess(res.data);
        })
    }
}